import { Button, Card, Form, FormProps, Input, notification } from 'antd';
import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AxiosService from '../services/axios-service';
import AuthService from '../services/auth-service';
import { LoginOutlined } from '@ant-design/icons';
import qelng from '../QELNG-logo.jpg'
import tamuq from '../TAMUQ-logo.png'

type FieldType = {
    email?: string;
    password?: string;
};

function LoginPage() {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    const onFormSubmit: FormProps<FieldType>['onFinish'] = (values) => {
        setIsLoading(true);
        const authService = AuthService.getInstance();
        if (authService.getCurrentUser()) {
            authService.logout().subscribe({
                next:() => {
                    authService.login(values.email!, values.password!).subscribe({ 
                        next:loginResponse=>{
                            authService.getCurrentUserFromServer().subscribe({ 
                                next:currentUserResponse=> {
                                    setIsLoading(false);
                                    notification.success({message:"Successful login"});
                                    navigate("/");
                                }, 
                            error:()=> {
                                setIsLoading(false);
                            }
                        });
                    }, error:()=> {
                        setIsLoading(false);
                    }});
                }, 
                error:()=> {
                    setIsLoading(false);
            }});
        } else {
            authService.login(values.email!, values.password!).subscribe({ 
                next:loginResponse=>{
                    authService.getCurrentUserFromServer().subscribe({ 
                        next:currentUserResponse=> {
                            setIsLoading(false);
                            notification.success({message:"Successful login"});
                            navigate("/");
                        }, 
                    error:()=> {
                        setIsLoading(false);
                    }
                });
            }, error:()=> {
                setIsLoading(false);
            }});
        }
    };
    
    
    return (
        <div style={{display:'flex',flexDirection:'column',alignItems: "center",justifyContent: "center",height:"100%"}}>
            <div style={{display:'flex', flexDirection:'row',gap:40}}>
                <Card style={{ width: 400 }}>
                    <div style={{textAlign:'center',height:220, alignContent:'center'}}>
                        <img src={qelng} alt="qenergy-logo" width={100} style={{margin:10}}/>
                        <img src={tamuq} alt="tamuq-logo" width={120} style={{margin:10}}/>
                    </div>
                </Card>
                <Card title="Login with your credentials" style={{ width: 400 }}>
                    <Form
                        layout='vertical'
                        style={{ maxWidth: 600 }}
                        onFinish={onFormSubmit}
                        autoComplete="off"
                    >
                        <Form.Item<FieldType>
                            label="Email"
                            name="email"
                            rules={[
                                { required: true, type:'email', message: 'Provide your email' },
                            ]}
                        >
                        <Input />
                        </Form.Item>

                        <Form.Item<FieldType>
                            label="Password"
                            name="password"
                            rules={[{ required: true, message: 'Provide your password' }]}
                        >
                        <Input.Password />
                        </Form.Item>

                        <div style={{textAlign:'center'}}>
                            <Button loading={isLoading} icon={<LoginOutlined/>} type="primary" htmlType="submit">
                                Log in
                            </Button>
                        </div>
                    </Form>
                </Card>
            </div>
        </div>
    );
}

export default LoginPage;